import * as Sentry from '@sentry/browser'

import { getIsPasswordLeaked, Auth, AuthConfig } from '@scouts/auth'
import { localStorageSet } from '@scouts/helpers'

import { trackIntercomEvent } from '@/actions'
import config from '@/config'
import { IS_PASSWORD_LEAKED_STORAGE_KEY } from '@/constants'
import { store } from '@/store'
import { saveProfile } from '@/store/profile'

const authConfig: AuthConfig = {
    firebaseApiKey: config.firebaseApiKey,
    firebaseAppId: config.firebaseAppId,
    firebaseAuthDomain: config.firebaseAuthDomain,
    firebaseAuthTenantId: config.firebaseAuthTenantId,
    firebaseProjectId: config.firebaseProjectId,
    firebaseRecaptchaEnterpriseSiteKey: config.firebaseRecaptchaEnterpriseSiteKey,
    privacyUrl: config.privacyUrl,
    termsUrl: config.termsUrl,
    tokenDurationMilliseconds: 1000 * 60 * 60 * 24,
    totpLabel: 'Taxfix',
    passwordLeakChecker: getIsPasswordLeaked,
    onLoginPasswordLeakChecked: (isLeaked) =>
        localStorageSet('taxscouts_' + IS_PASSWORD_LEAKED_STORAGE_KEY, JSON.stringify(isLeaked)),
    onSignupPasswordLeakChecked: (isLeaked) => {
        if (isLeaked) store.dispatch(trackIntercomEvent('sign-up-password-leaked'))
    },
    onEmailChanged: (email: string) => {
        store.dispatch(saveProfile({ email })).catch((error) => {
            Sentry.captureMessage('Email change failed during linking', {
                level: 'fatal',
                fingerprint: ['{{ default }}', 'EmailChangeError'],
                contexts: {
                    error: { message: error?.response?.data?.message || '' },
                },
            })
        })
    },
}

export const AuthenticationProvider = ({ children }: { children: React.ReactNode }) => {
    return <Auth.Provider config={authConfig}>{children}</Auth.Provider>
}
